import { useQuery } from "@apollo/client/react"; import { useState, useMemo, useEffect } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import ListaCondiciones from './ListaCondiciones';
import { AccionesVisita } from './AccionesVisita';
import columnsImporte from '../constants/columnsImporte';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { GET_ERRORES_BY_VISITA } from '../../../data/graphQL/queries/MisVisitas/getErroresByVisita';
import { adaptVisitaToHistorial } from '../constants/adapterHistorial';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { calculaPrecioExtraDuracion } from '../constants/helpers';
import ES_ENFERMERO_CUIDADOR from '../../../data/graphQL/queries/MisVisitas/esEnfermeroCuidadorAuxiliar';
import { GET_FRECUENCIA_BY_VISITA } from '../../../data/graphQL/queries/MisVisitas/getFrecuenciaByVisita';

const ID_ENFERMERO = 2;

export const DetalleAccionesModal = ({ visita }) => {
  const [openModal, setOpenModal] = useState(false);
  const [esCuidador, setEsCuidador] = useState(false);
  const historial = adaptVisitaToHistorial(visita);
  const importes = !!visita?.visitaHonorario[0] ? { ...visita?.visitaHonorario[0] } : null;

  const { data } = useQuery(GET_ERRORES_BY_VISITA, {
    variables: { idVisita: visita?.idVisita },
    fetchPolicy: "no-cache"
  });

  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = () => setOpenModal(false);

  const { data: dataEsEnfermoCuidador } = useQuery(ES_ENFERMERO_CUIDADOR, {
    fetchPolicy: 'no-cache',
    variables: { idVisita: visita?.idVisita }
  });

  const { data: dataFrecuenciaByVisita } = useQuery(GET_FRECUENCIA_BY_VISITA, {
    fetchPolicy: 'no-cache',
    variables: { idVisita: visita?.idVisita }
  });


  useEffect(() => {
    if (!dataEsEnfermoCuidador) return;
    setEsCuidador(!!dataEsEnfermoCuidador?.esEnfermeroCuidador);
  }, [dataEsEnfermoCuidador]);
  
    const columnsBase = [
      {
        field: 'presencial',
        headerName: 'H. Presencial',
        flex: 1,
        valueGetter: (honorarioPresencial) => { return `$${honorarioPresencial || 0}`; }
      },
      {
        field: 'virtual',
        headerName: 'H. Virtual',
        flex: 1,
        valueGetter: (honorarioVirtual) => { return `$${honorarioVirtual || 0}`; }
      },
      {
        field: 'tramo',
        headerName: 'Tramo',
        flex: 1,
        valueGetter: (tramo) => { return `$${tramo || 0}`; }
      },
      {
        field: 'cambioSonda',
        headerName: 'Cbio. Sonda',
        flex: 1,
        renderCell: (cellProps) => {
          const { row } = cellProps;
          return <RenderInputByTypeMobile
            input={{
              disableTypography: true,
              displayName: `$${row?.cambioSonda}`,
              name: 'checkCambioSonda',
              type: 'check',
              disabled: true
            }}
            value={!!row?.cambioSonda}
            ></RenderInputByTypeMobile>
        }
      },
      {
        field: 'capacitacion',
        headerName: 'Capacitación',
        flex: 1,
        renderCell: (cellProps) => {
          const { row } = cellProps;
          return <><RenderInputByTypeMobile
            input={{
              disableTypography: true,
              displayName: `$${row?.capacitacion}`,
              name: 'checkCapacitacion',
              type: 'check',
              disabled: true
            }}
            value={!!row?.capacitacion}
          />
            {row?.cambioSonda}</>;
        }
      },
      {
        field: 'emergencia',
        headerName: 'Urgencia',
        flex: 1,
        renderCell: (cellProps) => {
          const { row } = cellProps;
          return <RenderInputByTypeMobile
            input={{
              disableTypography: true,
              displayName: `$${row?.emergencia}`,
              name: 'checkEmergencia',
              type: 'check',
              disabled: true
            }}
            value={!!row?.emergencia}
             />;
  
        }
      },
      {
        field: 'extraDuracion',
        headerName: 'Ext. Duración',
        flex: 1,
        renderCell: (cellProps) => {
          const { row } = cellProps;
          const valorExtraDuracion = row.extraDuracion === 0 ? 0 : visita.idTipoProfesional == ID_ENFERMERO ? row.extraDuracion : calculaPrecioExtraDuracion(visita.fechaVisita, visita.fechaFinUsuario, row?.presencial, esCuidador, dataFrecuenciaByVisita?.frecuenciaByVisita?.frecuencia ?? 0);

          return <RenderInputByTypeMobile
            input={{
              disableTypography: true,
              displayName: `$${valorExtraDuracion}`,
              name: 'checkExtraDuracion',
              type: 'check',
              disabled: true
            }}
            value={!!valorExtraDuracion}
          />;
  
        }
      },
      {
        field: 'importeTotal',
        headerName: 'Importe Total',
        flex: 1,
        valueGetter: (total) => { return `$${total || 0}`; }
      }];
  
    const columns = useMemo(() => generateColumnsDefaultConfiguration(columnsBase), [visita, dataFrecuenciaByVisita]);


  if ((!historial || historial.length == 0) && !importes && data?.erroresByVisita?.length <= 0) return null;


  return <>
    <div aria-hidden='true' onClick={() => handleOpenModal()} className='item-option clickable-option'>
      <VisibilityIcon className='edit-icon' />
      <span className='toggle-action'>Ver Acciones</span>
    </div>
    <CustomDialog
      maxWidth="md"
      fullWidth={true}
      open={openModal}
      title={'Detalle de Acciones'}
      onCancel={handleCloseModal}>

      {!!importes && <DataGridGenerico
        columns={columns}
        rows={[importes]}
        autoMaxWidth
        totalCount={!!importes ? 1 : 0}
        toolbar={false}
        loading={false} />
      }
      {data?.erroresByVisita?.length > 0 && <ListaCondiciones items={data?.erroresByVisita ?? []} />}
      {!!historial && historial.length > 0 && <AccionesVisita historial={historial} />}
    </CustomDialog>
  </>;
};